// @flow
import {type MapViewport} from '../components/MapContainer/MapContainer';

export const BOUNDING_BOX_PARAMS = [
    'neLat',
    'neLong',
    'swLat',
    'swLong',
    'zoom'
];

export const WORLD_SEARCH_BOUNDS: MapViewport = {
    neLat: 82.12492067499629,
    neLong: 58.172218749999956,
    swLat: -78.48103194080132,
    swLong: -124.99184375000004
};
